// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19mlr","list":"styles_list__3VWWh","disableSelection":"styles_disableSelection__2C-T0"};